// Per-row currency-cell subtext helpers shared by the individual-investor
// Funds and SPVs list pages. Each returns an empty string when the underlying
// ratio can't be computed (no goal / no commitment / no calls) so the cell
// renders without a stray "0% ..." line.
//
// Data shape: assumes rows from `individualStore.fetchEntities`, where the
// performance numbers live under `insights.*` and the deal target under
// `deal_card.target_raise`. If a caller needs to consume the flat group-page
// shape (`item.committed`, `item.called`, …), add a `surface` option that
// switches accessors — same approach as entity-columns.ts.

export const pctOfGoal = (row: any): string => {
  const target = Number(row?.deal_card?.target_raise?.amount ?? 0)
  const committed = Number(row?.insights?.committed?.amount ?? 0)
  if (target <= 0) return '0% of goal'
  return `${Math.round((committed / target) * 100)}% of goal`
}

export const pctCalled = (row: any): string => {
  const committed = Number(row?.insights?.committed?.amount ?? 0)
  const called = Number(row?.insights?.called_total?.amount ?? 0)
  if (committed <= 0) return ''
  return `${Math.round((called / committed) * 100)}% called`
}

export const moicLabel = (row: any): string => {
  const called = Number(row?.insights?.called_total?.amount ?? 0)
  const distributed = Number(row?.insights?.portfolio_distributed?.amount ?? 0)
  if (called <= 0) return ''
  return `MOIC ${(distributed / called).toFixed(2)}x`
}

export const pctDeployed = (row: any): string => {
  const called = Number(row?.insights?.called_total?.amount ?? 0)
  const cash = Number(row?.insights?.cash_position?.amount ?? 0)
  if (called <= 0) return ''
  return `${Math.round(((called - cash) / called) * 100)}% Deployed`
}
